import React, { useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route, useNavigate } from 'react-router-dom';
import AuthFlow from './components/AuthFlow';
import CartView from './components/CartView';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentPending from './components/PaymentPending';
import PaymentFailure from './components/PaymentFailure';
import MercadoPagoSuccess from './components/MercadoPagoSuccess';
import NewsPage from './components/NewsPage';
import TicketView from './components/TicketView';
import CookieBanner from './components/CookieBanner';
import { CartProvider } from './contexts/CartContext';
import { ColorProvider } from './contexts/ColorContext';
import { initializeSession } from './utils/userStorage';
import './App.css';

const CartRoute: React.FC = () => {
  const navigate = useNavigate();
  return <CartView onGoBack={() => navigate('/tendencias')} />;
};

function App() {
  // 🚀 Inicializar gestor de sesión al cargar la app
  useEffect(() => {
    const sessionStatus = initializeSession();
    console.log('🚀 App inicializada con estado de sesión:', sessionStatus);
  }, []);

  return (
    <Router>
      <div className="App">
        <ColorProvider>
          <CartProvider>
            <Routes>
              <Route path="/" element={<AuthFlow />} />
              <Route path="/dashboard" element={<AuthFlow />} />
              <Route path="/cart" element={<CartRoute />} />
              <Route path="/tendencias" element={<NewsPage />} />
              <Route path="/novedades" element={<Navigate to="/tendencias" replace />} />
              <Route path="/ticket/:ticketId" element={<TicketView />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/pending" element={<PaymentPending />} />
              <Route path="/payment/failure" element={<PaymentFailure />} />
              <Route path="/mercadopago/success" element={<MercadoPagoSuccess />} />
            </Routes>
            {/* 🍪 Banner de Cookies - Aparece en todas las páginas */}
            <CookieBanner />
          </CartProvider>
        </ColorProvider>
      </div>
    </Router>
  );
}

export default App;
